const actions = {
  GET_ALL_MCQ_TESTS: "GET_ALL_MCQ_TESTS",
  GET_ALL_MCQ_TESTS_SUCCESS: "GET_ALL_MCQ_TESTS_SUCCESS",
  GET_ALL_SUBJECTS: "GET_ALL_SUBJECTS",
  GET_ALL_SUBJECTS_SUCCESS: "GET_ALL_SUBJECTS_SUCCESS",
  GET_ALL_CLASSES: "GET_ALL_CLASSES",
  GET_ALL_CLASSES_SUCCESS: "GET_ALL_CLASSES_SUCCESS",
  GET_ALL_SCHOOLS: "GET_ALL_SCHOOLS",
  GET_ALL_SCHOOLS_SUCCESS: "GET_ALL_SCHOOLS_SUCCESS",
  UPLOAD_TEST_DETAILS: "UPLOAD_TEST_DETAILS",
  UPLOAD_TEST_DETAILS_SUCCESS: "UPLOAD_TEST_DETAILS_SUCCESS",
  UPLOAD_ASSERTION_FILE: "UPLOAD_ASSERTION_FILE",
  UPLOAD_ASSERTION_FILE_SUCCESS: "UPLOAD_ASSERTION_FILE_SUCCESS",
  EDIT_TEST_DETAILS: "EDIT_TEST_DETAILS",
  EDIT_TEST_DETAILS_SUCCESS: "EDIT_TEST_DETAILS_SUCCESS",
  DELETE_TEST: "DELETE_TEST",
  SET_MCQ_LOADING: "SET_MCQ_LOADING",
  SET_TABLE_LOADING: "SET_TABLE_LOADING",
  SET_MCQ_ERROR: "SET_MCQ_ERROR",
  GET_TEST_REPORT: "GET_TEST_REPORT",
  SET_TEST_REPORT: "SET_TEST_REPORT",
  UPLOAD_ASSERTION_USER: "UPLOAD_ASSERTION_USER",
  UPLOAD_ASSERTION_USER_SUCCESS: "UPLOAD_ASSERTION_USER_SUCCESS",
  RESET_ALL_SCHOOLS: "RESET_ALL_SCHOOLS",
  getAllMCQ: (spinHandler) => ({
    type: actions.GET_ALL_MCQ_TESTS,
    spinHandler,
  }),
  getAllSubjects: (spinHandler) => ({
    type: actions.GET_ALL_SUBJECTS,
    spinHandler,
  }),
  getAllClasses: (spinHandler) => ({
    type: actions.GET_ALL_CLASSES,
    spinHandler,
  }),
  getAllSchools: (spinHandler) => ({
    type: actions.GET_ALL_SCHOOLS,
    spinHandler,
  }),
  uploadTestDetails: (payload, spinner) => ({
    type: actions.UPLOAD_TEST_DETAILS,
    payload,
    spinner,
  }),
  uploadAssertionFile: (payload, cb) => ({
    type: actions.UPLOAD_ASSERTION_FILE,
    payload,
    cb,
  }),

  AssertionUser: (payload, cb) => ({
    type: actions.UPLOAD_ASSERTION_USER,
    payload,
    cb,
  }),
  editTestDetails: (payload, spinner) => ({
    type: actions.EDIT_TEST_DETAILS,
    payload,
    spinner,
  }),
  deleteMCQTest: (payload, spinner) => ({
    type: actions.DELETE_TEST,
    payload,
    spinner,
  }),
  getReport: (payload) => ({
    type: actions.GET_TEST_REPORT,
    payload,
  }),
  resetAllSchools: () => ({
    type: actions.RESET_ALL_SCHOOLS,
  }),
};
export default actions;
